<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <div class="title-bc">{{ $t("m.index.setting.systemSetting") }}</div>
        </div>
      </div>
      <!--内容-->
      <div class="box-content">
        <div class="box-setting">
          <el-form :model="unitForm" ref="unitForm" :rules="unitForm.rules">
            <el-form-item prop="unit">
              <span class="cus-input-title">{{
                $t("m.index.setting.tempUnit")
              }}</span>
              <el-select
                v-model="unitForm.unit"
                filterable
                allow-create
                default-first-option
                :placeholder="$t('m.index.setting.tempUnit')"
              >
                <el-option
                  v-for="item in unitOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="weight">
              <span class="cus-input-title">{{
                $t("m.index.setting.weightUnit")
              }}</span>
              <el-select
                v-model="unitForm.weight"
                filterable
                allow-create
                default-first-option
                :placeholder="$t('m.index.setting.weightUnit')"
              >
                <el-option
                  v-for="item in weightOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-top:20px;">
              <el-button
                type="warning"
                style="float:right;padding:10px 20px;"
                @click="saveUnitClick"
              >
                {{ $t("m.button.save") }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="box-setting" name="system">
          <div class="flex input-wrap " style="width:100%;">
            <el-input type="textarea" :rows="6" v-model="descri"></el-input>
          </div>
          <el-button
            type="warning"
            v-if="role == 1"
            @click="saveAbout"
            style="float:right;padding:10px 20px;"
            >{{ $t("m.button.save") }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import E from "wangeditor";

export default {
  name: "systemManage",
  mounted() {
    if (this.role == 1) {
      this.activeName = "deviceManage";
    } else if (this.role == 0) {
      this.activeName = "unit";
    }
    //this.loadEventList()
    this.getMaintainInfo();
    this.getUnitInfo();
    //this.loadDeviceList()
    let e = new E("#editor");
    e.create();
    this.wangEditor = e;
  },
  data() {
    return {
      role: localStorage.role,
      activeName: "unit",
      eventList: [],
      addEventDialog: false,
      addEventForm: {
        name: "",
        sort: 0,
        note: "",
        rules: {
          name: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter event name"
                  : "请输入事件名称",
              trigger: "blur",
            },
          ],
          sort: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter order"
                  : "请输入顺序",
              trigger: "blur",
            },
          ],
          note: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter description"
                  : "请输入描述",
              trigger: "blur",
            },
          ],
        },
      },

      deviceList: [],
      devicePage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      addDeviceForm: {
        name: "",
        note: "",
        rules: {
          name: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter the machine name"
                  : "请输入设备名称",
              trigger: "blur",
            },
          ],
          note: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter description description"
                  : "请输入描述",
              trigger: "blur",
            },
          ],
        },
      },
      addDeviceDialog: false,
      deviceOptions: [
        { value: "M2G", label: "M2G" },
        { value: "M2E", label: "M2E" },
        { value: "M6G", label: "M6G" },
        { value: "M6E", label: "M6E" },
        { value: "L2", label: "L2" },
        { value: "L6", label: "L6" },
        { value: "PEAK", label: "PEAK" },
        { value: "P30", label: "P30" },
      ],
      deviceNoteOptions: [
        { value: "200g", label: "200g" },
        { value: "600g", label: "600g" },
        { value: "2000g", label: "2000g" },
        { value: "6000g", label: "6000g" },
      ],
      unitForm: {
        unit: "",
        weight: "",
        rules: {
          unit: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please select the temperature unit"
                  : "请选择温度单位",
              trigger: "blur",
            },
          ],
          weight: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please select the weight unit"
                  : "请选择重量单位",
              trigger: "blur",
            },
          ],
        },
      },
      unitOptions: [
        { value: "℃", label: "℃" },
        { value: "℉", label: "℉" },
      ],
      weightOptions: [
        { value: "kg", label: "kg" },
        { value: "g", label: "g" },
      ],
      settingInfoForm: {
        about: "",
        majorMaintain: 0,
        miniMaintain: 0,
        id: 1,
        rules: {
          majorMaintain: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter a large period"
                  : "请输入大周期",
              trigger: "blur",
            },
          ],
          miniMaintain: [
            {
              required: true,
              message:
                this.$i18n.locale === "en-US"
                  ? "Please enter a small period"
                  : "请输入小周期",
              trigger: "blur",
            },
          ],
        },
      },
      wangEditor: null,
      headers: {},
      selectDevice: null,
      selectIndex: 0,
      descri: "",
    };
  },
  methods: {
    uploadDeviceUserGuide(index, device) {
      console.info(index);
      console.info(device);
      this.selectDevice = device;
      this.selectIndex = index;
    },
    addDeviceClick() {
      this.$refs["addDeviceForm"].validate((valid) => {
        if (valid) {
          console.info("表单验证通过");
          this.$confirm(
            this.$t("m.alert.addConfirm"),
            this.$t("m.alert.reminder"),
            {
              confirmButtonText: this.$t("m.alert.confirm"),
              cancelButtonText: this.$t("m.alert.cancel"),
              type: "warning",
            }
          )
            .then(() => {
              let params = new URLSearchParams();
              params.append("name", this.addDeviceForm.name);
              params.append("note", this.addDeviceForm.note);
              this.$http
                .post("/manage/deviceType/add.do", params)
                .then(
                  function(resp) {
                    if (resp.data.success) {
                      this.$message.success(this.$t("m.alert.addSuccess"));
                      this.addDeviceDialog = false;
                      this.loadDeviceList();
                    } else {
                      this.$message.error(this.$t("m.alert.addError"));
                    }
                  }.bind(this)
                )
                .catch((err) => {
                  console.info(err);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: this.$t("m.alert.canceled"),
              });
            });
        }
      });
    },
    addEventClick() {
      this.$refs["addEventForm"].validate((valid) => {
        if (valid) {
          console.info("表单验证通过");
          this.$confirm(
            this.$t("m.alert.addConfirm"),
            this.$t("m.alert.reminder"),
            {
              confirmButtonText: this.$t("m.alert.confirm"),
              cancelButtonText: this.$t("m.alert.cancel"),
              type: "warning",
            }
          )
            .then(() => {
              let params = new URLSearchParams();
              params.append("name", this.addEventForm.name);
              params.append("note", this.addEventForm.note);
              params.append("sort", this.addEventForm.sort);
              this.$http
                .post("/manage/event/add.do", params)
                .then(
                  function(resp) {
                    if (resp.data.success) {
                      this.$message.success(this.$t("m.alert.addSuccess"));
                      this.addEventDialog = false;
                      this.loadEventList();
                    } else {
                      this.$message.error(this.$t("m.alert.addError"));
                    }
                  }.bind(this)
                )
                .catch((err) => {
                  console.info(err);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: this.$t("m.alert.canceled"),
              });
            });
        }
      });
    },
    deleteEventClick(index, event) {
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let params = new URLSearchParams();
          params.append("id", event.id);
          this.$http
            .post("/manage/event/delete.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.deleteSuccess"));
                  this.eventList.splice(index, 1);
                } else {
                  this.$message.error(this.$t("m.alert.deleteError"));
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },
    loadEventList() {
      this.$http
        .get("/manage/event/list.do")
        .then(
          function(resp) {
            this.eventList = resp.data.data;
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    loadDeviceList() {
      this.$http
        .get("/manage/deviceType/list.do", {
          params: {
            pageNum: this.devicePage.pageNum,
            pageSize: this.devicePage.pageSize,
          },
        })
        .then(
          function(resp) {
            if (resp.data.success) {
              this.deviceList = resp.data.data.list;
              this.devicePage.total = resp.data.data.total;
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    deleteDevice(index, device) {
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let params = new URLSearchParams();
          params.append("deviceTypeId", device.id);
          this.$http
            .post("/manage/deviceType/delDeviceType.do", params)
            .then(
              function(resp) {
                if (resp.data.success) {
                  this.$message.success(this.$t("m.alert.deleteSuccess"));
                  this.deviceList.splice(index, 1);
                } else {
                  this.$message.error(this.$t("m.alert.deleteError"));
                }
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },
    getMaintainInfo() {
      this.$http
        .get("/manage/setting/get.do")
        .then(
          function(resp) {
            if (resp.data.success) {
              this.settingInfoForm.about = resp.data.data.about;
              this.settingInfoForm.majorMaintain = resp.data.data.majormaintian;
              this.settingInfoForm.miniMaintain = resp.data.data.minimaintain;
              this.settingInfoForm.id = resp.data.data.id;
              this.wangEditor.txt.html(this.settingInfoForm.about);
              this.descri = this.settingInfoForm.about;
            } else {
              this.$message.error(this.$t("m.alert.error"));
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    getUnitInfo() {
      this.$http
        .get("/manage/userSetting/get.do")
        .then(
          function(resp) {
            if (resp.data.success) {
              this.unitForm.unit = resp.data.data.temunit;
              this.unitForm.weight = resp.data.data.weight;
            } else {
              this.$message.error(this.$t("m.alert.error"));
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    saveMaintainClick() {
      this.$refs["settingInfoForm"].validate((valid) => {
        if (valid) {
          console.info("确定保存维保周期信息");
          this.$confirm(
            this.$t("m.alert.saveConfirm"),
            this.$t("m.alert.reminder"),
            {
              confirmButtonText: this.$t("m.alert.confirm"),
              cancelButtonText: this.$t("m.alert.cancel"),
              type: "warning",
            }
          )
            .then(() => {
              let params = new URLSearchParams();
              params.append(
                "majormaintain",
                this.settingInfoForm.majorMaintain
              );
              params.append("minimaintain", this.settingInfoForm.miniMaintain);
              params.append("id", this.settingInfoForm.id);
              this.$http
                .post("/manage/setting/update.do", params)
                .then(
                  function(resp) {
                    if (resp.data.success) {
                      this.$message.success(this.$t("m.alert.updateSuccess"));
                    } else {
                      this.$message.error(this.$t("m.alert.updateError"));
                    }
                  }.bind(this)
                )
                .catch((err) => {
                  console.info(err);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: this.$t("m.alert.canceled"),
              });
            });
        }
      });
    },

    saveUnitClick() {
      this.$refs["unitForm"].validate((valid) => {
        if (valid) {
          this.$confirm(
            this.$t("m.alert.changeTip"),
            this.$t("m.alert.reminder"),
            {
              confirmButtonText: this.$t("m.alert.confirm"),
              cancelButtonText: this.$t("m.alert.cancel"),
              type: "warning",
            }
          )
            .then(() => {
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                 background: "rgba(0, 0, 0, 0.7)",
              });
              this.loading = loading;
              let params = new URLSearchParams();
              params.append("userid", localStorage.userid);
              params.append("temunit", this.unitForm.unit);
              params.append("weight", this.unitForm.weight);
              this.$http
                .post("/manage/userSetting/saveOrUpdate.do", params)
                .then(
                  function(resp) {
                    if (resp.data.success) {
                      localStorage.temUnit = this.unitForm.unit;
                      localStorage.weight = this.unitForm.weight;
                      this.$message.success(this.$t("m.alert.updateSuccess"));
                    } else {
                      this.$message.error(this.$t("m.alert.updateError"));
                    }
                  }.bind(this)
                )
                .catch((err) => {
                  console.info(err);
                });
              loading.close();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: this.$t("m.alert.canceled"),
              });
            });
        }
      });
    },

    saveAbout() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
      });
      this.loading = loading;
      let params = new URLSearchParams();
      params.append("id", 1);
      params.append("about", this.descri);
      this.$http
        .post("/manage/setting/update.do", params)
        .then(
          function(resp) {
            if (resp.data.success) {
              this.$message.success(this.$t("m.alert.updateSuccess"));
            } else {
              this.$message.error(
                this.$t("m.alert.saveError")
              );
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
      loading.close();
    },
    uploadDeviceGuideSuccess(response, file, fileList) {
      console.info(response);
      console.info(file);
      console.info(fileList);
      let params = new URLSearchParams();
      params.append("deviceTypeId", this.selectDevice.id);
      params.append("file", response.data.url);
      this.$http
        .post("/manage/deviceType/updatePath.do", params)
        .then(
          function(resp) {
            if (resp.data.success) {
              this.$message.success(this.$t("m.alert.updateSuccess"));
            } else {
              this.$message.error(
                this.$t("m.alert.saveError")
              );
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
  },
};
</script>
